<template>
  <DynamicText
    :id="marketBranding?.marketNameFont"
    :key="marketName"
    tag="span"
    styleGroup="Bet Market"
    :get="marketNameStyle.get"
    :set="marketNameStyle.set"
    :class="['market-name', classes.marketName]"
  >
    {{ marketName }}
  </DynamicText>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { createUseStyles } from "@fresh8/vue-jss/src";

const useStyles = createUseStyles({
  marketName: {
    fontSize: "10px",
    lineHeight: 1,
    textAlign: "center",
    justifyContent: "center"
  }
});
import { composeMarket } from "@fresh8/ad-data-composition/src/betData";
import DynamicText from "./DynamicText.vue";
import { Brand } from "@fresh8/types/src";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";

export default defineComponent({
  name: "MarketName",
  components: {
    DynamicText
  },
  props: {
    marketId: { type: String, required: true },
    fallbackName: { type: String, required: false, default: "" }
  },
  setup(props) {
    const classes = useStyles();
    const { marketBranding } = injectBrand();
    const market = composeMarket(props.marketId);

    const marketName = computed(
      () => market.value?.marketName || props.fallbackName
    );

    return {
      classes,
      marketName,
      marketBranding,
      marketNameStyle: {
        get(brand: Brand | undefined) {
          return brand && brand.adTemplate.market.marketNameFont;
        },
        set(brand: Brand, value: string) {
          brand.adTemplate.market.marketNameFont = value;
        }
      }
    };
  }
});
</script>
